import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "password", "passwordConfirmation", "submitButton", "match", "length",
                    "uppercase", "lowercase", "number", "special" ]

  connect() {
    this.checkPasswordComplexity();

    this.passwordTarget.addEventListener('input', this.checkPasswordComplexity.bind(this));
    this.passwordConfirmationTarget.addEventListener('input', this.checkPasswordComplexity.bind(this));
  }

  checkPasswordComplexity() {
    let canSubmit = true;
    const requirementMetMarkup = '✅<span class="visually-hidden"> Met</span>';
    const requirementNotMetMarkup = '❌<span class="visually-hidden"> Not met</span>';

    if ( (this.passwordTarget.value !== this.passwordConfirmationTarget.value) || (this.passwordTarget.value.length === 0 || this.passwordConfirmationTarget.value.length === 0) ) {
      this.matchTarget.innerHTML = requirementNotMetMarkup;
      canSubmit = false;
    } else {
      this.matchTarget.innerHTML = requirementMetMarkup;
    }

    if (this.passwordTarget.value.length < 8) {
      this.lengthTarget.innerHTML = requirementNotMetMarkup;
      canSubmit = false;
    } else {
      this.lengthTarget.innerHTML = requirementMetMarkup;
    }

    if (!this.passwordTarget.value.match(/[A-Z]/)) {
      this.uppercaseTarget.innerHTML = requirementNotMetMarkup;
      canSubmit = false;
    } else {
      this.uppercaseTarget.innerHTML = requirementMetMarkup;
    }

    if (!this.passwordTarget.value.match(/[a-z]/)) {
      this.lowercaseTarget.innerHTML = requirementNotMetMarkup;
      canSubmit = false;
    } else {
      this.lowercaseTarget.innerHTML = requirementMetMarkup;
    }

    if (!this.passwordTarget.value.match(/[0-9]/)) {
      this.numberTarget.innerHTML = requirementNotMetMarkup;
      canSubmit = false;
    } else {
      this.numberTarget.innerHTML = requirementMetMarkup;
    }

    if (!this.passwordTarget.value.match(/[#?!@$%^&*-]/)) {
      this.specialTarget.innerHTML = requirementNotMetMarkup;
      canSubmit = false;
    } else {
      this.specialTarget.innerHTML = requirementMetMarkup;
    }

    if (canSubmit) {
      this.submitButtonTarget.removeAttribute('disabled');
      this.submitButtonTarget.classList.remove('disabled');
    } else {
      this.submitButtonTarget.setAttribute('disabled', '');
      this.submitButtonTarget.classList.add('disabled');
    }
  }
}
